export interface EmailPreferences {
    liveStreamEmails: boolean;
    corridorNewsEmails: boolean;
    corridorStoreEmails: boolean;
    videoNotificationEmails: boolean;
}
